import { FC, useState } from 'react';

import { Document, Padding, Tags } from 'types';

import downloadDocument from 'utils/downloadDocument';
import { generateDocumentWithTags } from 'utils/generateDocumentWithTags';

import documentTypes from 'constants/documentTypes';

import { ReplaceDocumentTagsSources } from 'modules/documents/api/replaceDocumentTags';

import CustomLoading from '../../CustomLoading';

type DownloadDocumentProps = {
  document: Document;
  downloadName?: string;
  sources?: ReplaceDocumentTagsSources;
  tagsObject?: Tags;
  templateWatermarkText?: string;
  templateBackgroundImage?: string;
  templateTextPadding?: Padding;
  isLandscape?: boolean;
};

const DownloadDocument: FC<DownloadDocumentProps> = ({
  document,
  downloadName,
  sources,
  templateWatermarkText,
  templateBackgroundImage,
  templateTextPadding,
  isLandscape,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleDownloadTemplateDocument = async () => {
    await generateDocumentWithTags({
      documentId: document._id,
      documentName: downloadName || document?.name || 'Template Document',
      documentHtml: document?.editorModel || '',
      sources: sources || {},
      language: 'es',
      footerHtml: '',
      watermarkText: templateWatermarkText,
      backgroundImage: templateBackgroundImage,
      textPadding: templateTextPadding,
      showOnlyValues: false,
      isLandscape,
    });
  };

  const handleDownloadRegularDocument = () => {
    downloadDocument({
      documentId: document?._id,
      documentName: downloadName || document?.name,
      documents: [],
    });
  };

  const handleDownloadDocument = async () => {
    try {
      setIsLoading(true);
      if (document.category === documentTypes.TEMPLATES) {
        await handleDownloadTemplateDocument();
      } else {
        handleDownloadRegularDocument();
      }
    } catch (error) {
      console.error(error); // eslint-disable-line no-console
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-icon btn-trigger"
        onClick={handleDownloadDocument}
      >
        <em className="icon ni ni-file-download" />
      </button>

      {isLoading && <CustomLoading />}
    </>
  );
};

export default DownloadDocument;
